		<template>
  <section class="py-5 px-3" style="background-color: #eef9f3;">
    <div class="container">
      <div class="mx-auto p-4 bg-white shadow rounded" style="max-width: 720px;">
    <!-- Title -->
    <h1 class="display-6 text-center text-success mb-4" style="font-size: 2rem;">
      Safeguarding, Privacy & Policies
    </h1>

    <!-- Intro -->
    <p class="mb-3" style="font-size: 1.05rem;">
      We believe that great Computer Science education goes hand in hand with responsibility, safety, and trust.
      Just as we teach students to build reliable systems, we apply the same principles to how we work with people and data.
    </p>

    <!-- 1. Safeguarding -->
    <h4 class="mt-4 text-success">1. Safeguarding</h4>

    <p class="mb-2">
      <strong>Our Commitment:</strong><br>
      The safety and wellbeing of children and young people is our highest priority.
      We are committed to providing a safe, respectful, and supportive learning environment.
    </p>

    <p class="mb-2">
      <strong>Online Learning:</strong><br>
      Lessons are conducted using approved and secure platforms. Communication remains professional,
      appropriate, and focused on education.
    </p>

    <p class="mb-2">
      <strong>Reporting Concerns:</strong><br>
      Any safeguarding concerns are taken seriously and handled appropriately.
    </p>

    <p class="mb-3">
      <strong>Contact:</strong><br>
      safeguarding:
    </p>

    <!-- 2. Privacy -->
    <h4 class="mt-4 text-success">2. Privacy Policy</h4>

    <p class="mb-2">
      <strong>Information We Collect:</strong><br>
      Name, email address, and details submitted via contact forms.
    </p>

    <p class="mb-2">
      <strong>How We Use Data:</strong><br>
      To respond to enquiries, provide services, and improve user experience.
    </p>

    <p class="mb-2">
      <strong>Data Protection:</strong><br>
      Your data is stored securely and never sold to third parties.
    </p>

    <p class="mb-3">
      <strong>Your Rights:</strong><br>
      You may request access, correction, or deletion of your data at any time.
    </p>

    <!-- 3. Terms -->
    <h4 class="mt-4 text-success">3. Terms & Conditions</h4>

    <p class="mb-2">
      <strong>Services:</strong><br>
      GCSE & A-Level support, workshops, and school partnerships.
    </p>

    <p class="mb-2">
      <strong>Bookings:</strong><br>
      Sessions must be arranged and confirmed in advance.
    </p>

    <p class="mb-2">
      <strong>Cancellations:</strong><br>
      Reasonable notice is required.
    </p>

    <p class="mb-3">
      <strong>Responsibilities:</strong><br>
      Students and parents are expected to support a respectful and focused learning environment.
    </p>

    <!-- 4. Cookies -->
    <h4 class="mt-4 text-success">4. Cookies (Planned)</h4>

    <p class="mb-3">
      We may use cookies (e.g., analytics tools) in the future to improve user experience.
      A full cookie policy will be provided when implemented.
    </p>

    <!-- Closing Philosophy -->
    <h5 class="mt-4 text-success">Our Approach</h5>

    <p>
      Just as in Computer Science, systems must be secure, data must be handled responsibly,
      and networks must be trusted. We apply these same principles to our educational environment,
      helping students become not only successful learners but responsible digital citizens.
    </p>

  </div>
</div>


  </section>
</template>